import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Table, Dimmer, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {getNumericValue} from '../../../common/util/fieldsValidation';

class UsageTable extends Component {
  componentDidMount() {
    this.props.getWarehouseLocationsUsage();
  }

  parseType(type) {
    const types = {
      'locationsCount': 'Total ubicaciones',
      'usedLocations': 'Total ubicaciones con Stock',
    };
    return types[type] || '% de Ocupación';
  }

  parseTextValue(type, value = 0) {
    if (type === 'usagePercentage') {
      return `${Math.round(value)}%`;
    }
    return getNumericValue(value);
  }

  renderHeader() {
    return (
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>
            <h3>Valor</h3>
          </Table.HeaderCell>
          {this.renderZoneNames()}
          <Table.HeaderCell className='header'>
            <strong>TOTAL</strong>
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }

  renderZoneNames() {
    const {usageByZone} = this.props;

    return usageByZone.map((item, index) => {
      return (
        <Table.HeaderCell className='header' key={index}>
          {item.zoneName}
        </Table.HeaderCell>
      );
    });
  }

  renderValues() {
    const types = ['locationsCount', 'usedLocations', 'usagePercentage'];

    return (
      <Table.Body>
        {types.map((item, index) => this.renderDataRow(item, index))}
      </Table.Body>
    );
  }

  renderDataRow(type, key) {
    const firstColumnText = this.parseType(type);

    return (
      <Table.Row key={key}>
        <Table.Cell>{firstColumnText}</Table.Cell>
        {this.renderRowValues(type)}
        <Table.Cell className='value'>
          {this.parseTextValue(type, this.props[type])}
        </Table.Cell>
      </Table.Row>
    );
  }

  renderRowValues(type) {
    const {usageByZone} = this.props;

    return usageByZone.map((item, index) => {
      return (
        <Table.Cell className='value' key={index}>
          {this.parseTextValue(type, item[type])}
        </Table.Cell>
      );
    });
  }

  render() {
    if (this.props.loading) {
      return (
        <Dimmer active inverted>
          <Loader>Obteniendo Información</Loader>
        </Dimmer>
      );
    }

    return (
      <Table>
        {this.renderHeader()}
        {this.renderValues()}
      </Table>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    usageByZone,
    loading,
    locationsCount,
    usedLocations,
    usagePercentage,
  } = state.warehouseLocationsUsage;

  return {
    loading,
    locationsCount,
    usedLocations,
    usagePercentage,
    usageByZone,
  };
};

const {getWarehouseLocationsUsage} = Actions;

export default connect(mapStateToProps, {getWarehouseLocationsUsage})(
  UsageTable
);
